/*
 * Copyright (c) 2019 LabKey Corporation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from 'react';
import { Map } from 'immutable';

interface AssayRunReferenceRendererProps {
    data: Map<any, any>;
}

export class AssayRunReferenceRenderer extends React.Component<AssayRunReferenceRendererProps, any> {
    render() {
        const { data } = this.props;
        const displayValue = data && data.size > 0 ? data.get('displayValue') : undefined;
        const value = data && data.size > 0 ? data.get('value') : undefined;

        if (value) {
            let displayStr = 'Run ' + value;
            if (displayValue) {
                displayStr = displayValue + ' (' + displayStr + ')';
            }

            return (
                <div>
                    <a href={'#/rd/assayrun/' + value}>{displayStr}</a>
                </div>
            );
        }

        return null;
    }
}
